import { NavLink } from "react-router-dom";
import { memo } from "react";

import { classNames, useTranslate } from "helpers";
import { Routes as FleetTireRoutes } from "ui/modules/fleet/tires/navigation";
import { TabSearchMenuProps } from "./types";

const TabMenu: React.FC<TabSearchMenuProps> = () => {

  const { t } = useTranslate();

  return (
    <>
      <div className="flex bg-white">
        {/* <NavLink
          to={FleetTireRoutes.FleetTireSearchPageRouter}
          className={({ isActive }: { isActive: boolean }) =>
            classNames(
              isActive
                ? "text-sky-600 border-b-2 border-b-sky-600"
                : "text-gray-600",
              "font-semibold  px-4 py-2 hover:text-sky-600 ml-3 whitespace-nowrap"
            )
          }
        >
          {t("admin.fleet.tire.tab.search")}
        </NavLink> */}
        <NavLink
          to={FleetTireRoutes.FleetTireSetSearchPageRouter}
          className={({ isActive }: { isActive: boolean }) =>
            classNames(
              isActive
                ? "text-sky-600 border-b-2 border-b-sky-600"
                : "text-gray-600",
              "font-semibold  px-4 py-2 hover:text-sky-600 ml-3 whitespace-nowrap"
            )
          }
        >
          {t("admin.fleet.tire.tab.search.set")}
        </NavLink>

      </div>
    </>
  );
};

export default memo(TabMenu);
